// Returns only the components that needs to be render from zendesk article labels
import Vue from 'vue'
const req = require.context('../../widgets', true, /\.(vue)$/i)

export const getComponents = screenWidgets => {
  const vueComps = []
  screenWidgets.forEach(w => {
    const key = Object.keys(w)[0]
    mutateKey(w, key, toCamel(key))
  })

  const labels = getTags(screenWidgets)

  req.keys().map(key => {
    const fileName = key.match(/\w+/)[0]
    let { name: label } = req(key).default
    let labelMatch = labels.filter(l => l.name === label)

    if (labelMatch.length > 0) {
      for (let _label of labelMatch) {
        const comp = {
          label: _label.name,
          key: _label.id,
          data: screenWidgets[_label.id][deCapitalize(_label.name)] || {},
          component: () => Vue.component(fileName, req(key)).default,
        }
        vueComps.push(comp)
      }
    }
  })

  const result = sortFromLabels(vueComps, labels)
  return result
}

export const getScreenWidgets = screenWidgets => {
  const widgets = processWidgets(screenWidgets)
  return widgets
}

export const getToHide = widgets => {
  const toHide = []
  widgets.map(({ data: { evaluate } }) => {
    if(evaluate) {
      for (const i in evaluate) {
        toHide.push(evaluate[i])
      }
    }
  })
  return toHide
}

const sortFromLabels = (components, labels) => {
  const result = []
  labels.forEach(label => {
    result.push(components.find(comp => comp.key === label.id))
  })
  return result
}

const getTags = screenWidgets => {
  let id = 0
  return screenWidgets.map(widget => {
    const name = capitalize(toCamel(Object.getOwnPropertyNames(widget)[0]))
    return {
      id: id++,
      name,
    }
  })
}

const processWidgets = screenWidgets => {
  return screenWidgets.map((widget, i) => {
    const baseName = Object.getOwnPropertyNames(widget)[0]
    const localName = capitalize(toCamel(baseName))
    return {
      key: i,
      label: localName,
      data: widget[baseName],
      component: () =>
        Vue.component(localName, req(`./${localName}.vue`)).default,
    }
  })
}

const capitalize = ([s, ...tring]) => {
  return [s.toUpperCase(), ...tring].join('')
}

const deCapitalize = ([s, ...tring]) => {
  return [s.toLowerCase(), ...tring].join('')
}

const toCamel = s => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const mutateKey = (o, oldKey, newKey) => {
  if (oldKey === newKey) return o

  const obj = Object.assign(o, { [newKey]: o[oldKey] })
  delete obj[oldKey]

  return obj
}
